import data from '@emoji-mart/data';
import { SearchIndex, init } from 'emoji-mart';
import { MessageInput, MessageList } from 'stream-chat-react';
import 'stream-chat-react/css/v2/index.css';
import { customRenderText } from '../custom-render-text';
import { customMessageActions } from './custom-message-actions';
import { DraftReply } from './draft-reply/draft-reply';

init({ data });

const ChannelInner = () => {

  return (
    <>
      <MessageList
        customMessageActions={customMessageActions}
        messageActions={['delete', 'edit', 'quote', 'react']}
        hideDeletedMessages
        renderText={customRenderText}
      />
      <DraftReply />
      <MessageInput
        focus
        audioRecordingEnabled
        asyncMessagesMultiSendEnabled
        emojiSearchIndex={SearchIndex}
        // override the default behavior of submitting the message on enter
        shouldSubmit={() => false}
      />
    </>
  );
};

export default ChannelInner;
